var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-symbols-sharp",style:(_vm.size?'font-size:'+_vm.size+'px;':'')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }